import script from "./PersonalAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalAccountView.vue?vue&type=script&setup=true&lang=js"

import "./PersonalAccountView.vue?vue&type=style&index=0&id=201417c9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201417c9"]])

export default __exports__